import {activityTopGet} from "api";

const convertActivityTopResult = (response) => {
    return response.map((item) => {
        item.top = item.top.map(({client, points}) => ({
            client: ko.observable(new Entity.Client(client)),
            points,
        }));

        return item;
    });
}

export default function($app) {
	const $locale = $app.require('locale');
	const $ui = $app.require('ui');

    const activityTop = ko.observableArray([]);

	this.title = ko.observable($locale.get('activity.title'));
	this.name = 'activity';
	this.position = ko.computed(() => $app.event().moduleActivity.position());
	this.isEnabled = ko.computed(() =>
		$app.event().moduleActivity.enabled()
        && $app.event().moduleActivity.position()
        && !($app.request.getParameter('hideFooter') && this.position() === 'bottom')
	);

	this.loading = ko.observable(false);
	this.top = ko.computed(() => {
        const currentStreamId = $app.currentStream()?.id();

        if ($app.event().moduleActivity.type() === 'event') {
            return activityTop()[0]?.top ?? [];
        }
        if ($app.event().moduleActivity.type() === 'stream') {
            return activityTop().find(({streamId}) => streamId === currentStreamId)?.top ?? [];
        }
        return [];
    });
	this.isEmpty = ko.computed(() => this.top().length === 0);

	this.init = () => {
        ko.computed(async () => {
            const result = await activityTopGet($app.event().eventKey());
            activityTop(convertActivityTopResult(result));
        });

        $app.require('comet')
            .on('activityTop', (result) => activityTop(convertActivityTopResult(result)))
        ;
    };

	$app.on('start', () => {
		if (!this.isEnabled()) {
            return;
        }

        this.uiTab = new $ui.Tab(this);
        setTimeout(this.init, 0);
    });
};
